// Баннеры v2 (MOB-470, эпик ANALYTICS-CONTRACT): banner_view / banner_click.
// banner_view запускает директива v-impression (правило показа v2), banner_click —
// старые функции клика. Старые события не трогаем, v2 — одно событие на действие.
import { track } from '@web/services/Analytics/v2/track'
import { getPageVisit } from '@web/services/Analytics/v2/currentPage'
import { placementOf } from '@web/services/Analytics/v2/placement'
import Logger from '@web/common/Logger'

export interface BannerV2 {
  bannerId: string
  // Позиция старой разметки как есть — в v2 переводится в словарь мест.
  oldPosition: string
  bannerType?: string | null
  // A/B-тест баннера (Banner.abTestId / Banner.variationId), есть не у всех.
  abTestId?: number | null
  variationId?: number | null
}

// Два обработчика одного клика срабатывают подряд; повтор с тем же баннером
// в пределах окна — тот же клик.
const CLICK_WINDOW_MS = 1000

const shownOnPage = new Set<string>()
const lastClickAt = new Map<string, number>()

// Для тестов.
export function resetBannerDedup (): void {
  shownOnPage.clear()
  lastClickAt.clear()
}

function params ({ bannerId, oldPosition, bannerType, abTestId, variationId }: BannerV2) {
  const { placement, position } = placementOf(oldPosition)
  return {
    object_id: bannerId,
    placement,
    ...(position !== undefined ? { position } : {}),
    ...(bannerType ? { banner_type: bannerType } : {}),
    ...(abTestId != null ? { banner_ab_test_id: String(abTestId) } : {}),
    ...(variationId != null ? { banner_ab_test_variant_id: String(variationId) } : {})
  }
}

// Обе функции зовутся из обработчиков показа и клика (в том числе до
// window.open), а данные приходят и из старого JS: ошибка аналитики не должна
// ронять вызывающий код.
export function trackBannerView (banner: BannerV2): void {
  try {
    // Один показ баннера за заход на экран: страховка, если один баннер стоит на
    // экране дважды. Ключ — номер захода, а не путь: вернулся на тот же экран —
    // новый заход, показ снова считается.
    const key = `${getPageVisit()}::${banner.bannerId}`
    if (shownOnPage.has(key)) return
    shownOnPage.add(key)
    track('banner_view', params(banner))
  } catch (e) {
    Logger.error('[Analytics v2] banner_view не отправлен', e)
  }
}

export function trackBannerClick (banner: BannerV2): void {
  try {
    const now = Date.now()
    const last = lastClickAt.get(banner.bannerId)
    lastClickAt.set(banner.bannerId, now)
    if (last !== undefined && now - last < CLICK_WINDOW_MS) return
    track('banner_click', params(banner))
  } catch (e) {
    Logger.error('[Analytics v2] banner_click не отправлен', e)
  }
}
